<div class="requisition-table">
  <div class="project-info">
    <h4>{{projectName}}</h4>
    <div class="project-info-buttons">
      <button nz-button nzType="default" nz-dropdown [nzDropdownMenu]="exportMenu"
        nzTrigger="click" [disabled]="!canPrint"
        nz-tooltip nzTooltipTitle="Exportar a excel">
        <span nz-icon nzType="file-excel"></span>
      </button>
      <button nz-button nzType="default" nz-dropdown [nzDropdownMenu]="columnsMenu" [nzClickHide]="false"
        nzTrigger="click" nzOverlayClassName="columns-menu-dropdown"
        nz-tooltip nzTooltipTitle="Visualización de columnas">
        <img src="assets/InsertColumnAboveOutlined.svg">
      </button>
    </div>
  </div>
  <nz-dropdown-menu #exportMenu="nzDropdownMenu">
    <ul nz-menu class="columns-menu-container">
      <li nz-menu-item>
        <a (click)="onExportRequisitions('all')">
          <span nz-icon nzType="file-excel" nzTheme="fill"></span>
          <span>Exportar toda la data en excel</span>
        </a>
      </li>
      <li nz-menu-item [nzDisabled]="selectedRequisitions.size === 0">
        <a (click)="onExportRequisitions('selected')">
          <span nz-icon nzType="file-excel" nzTheme="outline"></span>
          <span>Exportar celdas seleccionadas a excel</span>
        </a>
      </li>
    </ul>
  </nz-dropdown-menu>
  <nz-dropdown-menu #columnsMenu="nzDropdownMenu">
    <label class="column-selector">Selector de columnas</label>
    <input type="text" nz-input placeholder="Buscar columna" (input)="onFilterColumnsList($event)" />
    <ul nz-menu nzSelectable class="columns-menu-container">
      @for (column of requisitionCheckableColumnsList; track column.name) {
        @if (column.hasShowAndHideColumnFilter) {
          <li nz-menu-item>
            <label nz-checkbox [(ngModel)]="column.isVisible"
              disabled="{{column.title === 'ID Descripción'}}">{{column.title}}</label>
          </li>
        }
      }
    </ul>
  </nz-dropdown-menu>
  <nz-spin nzTip="Cargando..." [nzSpinning]="loading" [nzSize]="'large'">
  <nz-tabset [nzTabBarExtraContent]="clearAllFilters" [nzSelectedIndex]="currentTab">
    @for (tab of requisitionTabsList; track tab;let tabIndex = $index) {
    <nz-tab nzTitle={{tab}} (nzClick)="onChangeRequisitionTab(tabIndex)">
      <nz-table #sortTable [nzData]="requisitionTableData" nzTableLayout="fixed"
        [nzNoResult]="(!projectId || areFiltersEmpty) ? emptyRequisitions : emptyFilteredRequisitions"
        [nzScroll]="{ x: '950px' }" nzShowPagination="false" [nzPageSize]="pageSize"
        [nzTotal]="totalRequisitions">
        <thead>
          <tr>
            <th nzWidth="50px" nzAlign="center">
              <label nz-checkbox (nzCheckedChange)="onSelectAllRequisitions()" [(ngModel)]="areAllRequisitionsSelected"
                [nzDisabled]="requisitionTableDataBackup.length === 0"></label>
            </th>
            @for (column of requisitionColumnsList; track column.name) {
              @if (column.isVisible) {
                <th [nzWidth]="column.width" [nzAlign]="column.align === 'center' ? 'center'
                                          : column.align === 'right' ? 'right'
                                          : column.align === 'left' ? 'left'
                                          : null" style="white-space: pre-line;">
                  <div class="column-header">
                    <div>
                      {{ column.title }}
                      @if (column.name === 'requisitionTotalCost') {
                        <span nz-icon nzType="question-circle"
                          nz-tooltip nzTooltipTitle="Monto requisitado = PU x cantidad de todos los recursos de la requisición"></span>
                      }
                    </div>
                    @if (column.isSortable) {
                      <div class="sort-buttons">
                        <button class="sort-button" nz-button nzType="text" (click)="onSortColumn(column.name!)">
                          <span
                            [ngStyle]="(selectedSortColumn === column.name && selectedSortDirection === 'asc')
                              ? {color: '#69c0ff'}
                              : {color: ''}"
                            nz-icon nzType="caret-up" nzTheme="outline"></span>
                          <span
                            [ngStyle]="(selectedSortColumn === column.name && selectedSortDirection === 'desc')
                            ? {color: '#69c0ff'}
                            : {color: ''}"
                            nz-icon nzType="caret-down" nzTheme="outline"></span>
                        </button>
                      </div>
                    }
                  </div>
                </th>
              }
            }
          </tr>
          <tr>
            <th></th>
            @for (filter of requisitionColumnsList; track filter.name; let requisitionIndex = $index) {
              @if (filter.hasSearchFilter && filter.isVisible) {
                <th nzAlign="right">
                  @if (filter.name === 'userWhoBuys' && usersInRequisitions && usersInRequisitions.userWhoBuys) {
                  <nz-select class="filter-input" nzMode="multiple" nzPlaceHolder="Buscar usuario"
                    (ngModelChange)="onUserFilter($event, filter.name)" [(ngModel)]="selectedUserWhoBuys">
                    @for (user of usersInRequisitions.userWhoBuys; track user.id) {
                      <nz-option [nzLabel]="user.name || 'No disponible'" [nzValue]="user"></nz-option>
                    }
                  </nz-select>
                  } @else if (filter.name === 'userWhoRequests' && usersInRequisitions &&
                  usersInRequisitions.userWhoRequests) {
                  <nz-select class="filter-input" nzMode="multiple" nzPlaceHolder="Buscar usuario"
                    (ngModelChange)="onUserFilter($event, filter.name)" [(ngModel)]="selectedUserWhoRequests">
                    @for (user of usersInRequisitions.userWhoRequests; track user.id) {
                      <nz-option [nzLabel]="user.name || 'No disponible'" [nzValue]="user"></nz-option>
                    }
                  </nz-select>
                  } @else if (filter.name === 'userWhoReviews' && usersInRequisitions && usersInRequisitions.userWhoReviews){
                  <nz-select class="filter-input" nzMode="multiple" nzPlaceHolder="Buscar usuario"
                    (ngModelChange)="onUserFilter($event, filter.name)" [(ngModel)]="selectedUserWhoReviews">
                    @for (user of usersInRequisitions.userWhoReviews; track user.id) {
                      <nz-option [nzLabel]="user.name || 'No disponible'" [nzValue]="user"></nz-option>
                    }
                  </nz-select>
                  } @else if (filter.name === 'userWhoAuthorizes' && usersInRequisitions &&
                  usersInRequisitions.userWhoAuthorizes) {
                  <nz-select class="filter-input" nzMode="multiple" nzPlaceHolder="Buscar usuario"
                    (ngModelChange)="onUserFilter($event, filter.name)" [(ngModel)]="selectedUserWhoAuthorizes">
                    @for (user of usersInRequisitions.userWhoAuthorizes; track user.id) {
                      <nz-option [nzLabel]="user.name || 'No disponible'" [nzValue]="user"></nz-option>
                    }
                  </nz-select>
                  } @else if (filter.name === 'requisitionKey') {
                    <span>{{selectedIdFilter}}</span>
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedIdFilter"
                        [nzDropdownMenu]="idFilterMenu">
                        <span nz-icon nzType="search"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #idFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <div class="search-box">
                          <input class="search-box-input" [(ngModel)]="selectedIdFilter"
                            type="text" nz-input placeholder="Buscar..."/>
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary"
                              (click)="onIdFilterChange(selectedIdFilter)"
                              class="search-button">Buscar</button>
                            <button nz-button nzSize="small"
                              (click)="onResetIdFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </div>
                      </div>
                    </nz-dropdown-menu>
                  } @else if (filter.name === 'requisitionFolio') {
                    <span>{{selectedFolioFilter}}</span>
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedFolioFilter"
                        [nzDropdownMenu]="folioFilterMenu">
                        <span nz-icon nzType="search" (click)="onShowFolioFilter()"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #folioFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <form class="search-box" (ngSubmit)="onFolioFilterChange(selectedFolioFilter)">
                          <input class="search-box-input" [(ngModel)]="selectedFolioFilter"
                            name="folio" #folioInput
                            type="text" nz-input placeholder="Buscar..."/>
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary" type="submit"
                            class="search-button">Buscar</button>
                            <button nz-button nzSize="small" type="reset"
                              (click)="onResetFolioFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </form>
                      </div>
                    </nz-dropdown-menu>
                  } @else if (filter.name === 'requisitionDescription') {
                    <span>{{selectedDescriptionFilter}}</span>
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedDescriptionFilter"
                        [nzDropdownMenu]="descriptionFilterMenu">
                        <span nz-icon nzType="search" (click)="onShowDescriptionFilter()"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #descriptionFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <form class="search-box" (ngSubmit)="onDescriptionFilterChange(selectedDescriptionFilter)">
                          <input class="search-box-input" [(ngModel)]="selectedDescriptionFilter"
                            name="description" #descriptionInput
                            type="text" nz-input placeholder="Buscar..."/>
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary" type="submit"
                            class="search-button">Buscar</button>
                            <button nz-button nzSize="small" type="reset"
                              (click)="onResetDescriptionFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </form>
                      </div>
                    </nz-dropdown-menu>
                  } @else if (filter.name === 'requisitionProject') {
                    <span>{{selectedProjectFilter}}</span>
                    @if (currentTab === tabIndex) {
                      <nz-filter-trigger [(nzVisible)]="isSelectedProjectFilter"
                        [nzDropdownMenu]="projectFilterMenu">
                        <span nz-icon nzType="search" (click)="onShowProjectFilter()"></span>
                      </nz-filter-trigger>
                    }
                    <nz-dropdown-menu #projectFilterMenu="nzDropdownMenu">
                      <div class="ant-table-filter-dropdown">
                        <form class="search-box" (ngSubmit)="onProjectFilterChange(selectedProjectFilter)">
                          <input class="search-box-input" [(ngModel)]="selectedProjectFilter"
                            name="project" #projectInput
                            type="text" nz-input placeholder="Buscar..."/>
                          <div class="search-box-buttons">
                            <button nz-button nzSize="small" nzType="primary" type="submit"
                            class="search-button">Buscar</button>
                            <button nz-button nzSize="small" type="reset"
                              (click)="onResetProjectFilter()"
                              class="search-button">Borrar filtro</button>
                          </div>
                        </form>
                      </div>
                    </nz-dropdown-menu>
                  }
              </th>
              }
              @else if (filter.hasSelectableFilter && filter.isVisible) {
              <th nzAlign="right">
                @if (selectedPriority.length >= 0 && filter.name === 'requisitionPriority') {
                <div class="priority-status-filter-container">
                  @for (priority of selectedPriority; track priority.id) {
                  <app-priority-tag class="selectable-tag" [backgroundColor]="priority.backgroundColor"
                    [borderColor]="priority.borderColor" [label]="priority.label" [textColor]="priority.textColor"
                    (click)="onPriorityFilterChange(priority, false)">
                  </app-priority-tag>
                  }
                </div>
                }
                @else if (selectedStatus.length >= 0 && filter.name === 'requisitionStatus') {
                <div class="priority-status-filter-container">
                  @for (state of selectedStatus; track state.id) {
                  <app-status-tag class="selectable-tag" [backgroundColor]="state.backgroundColor"
                    [borderColor]="state.borderColor" [icon]="state.icon" [label]="state.label"
                    [textColor]="state.textColor" (click)="onStatusFilterChange(state, false)">
                  </app-status-tag>
                  }
                </div>
                }
                @else if (selectedProgress.length >= 0 && filter.name === 'requisitionProgress') {
                <div class="priority-status-filter-container">
                  @for (progress of selectedProgress; track progress.id) {
                  <app-status-tag class="selectable-tag" [backgroundColor]="progress.backgroundColor"
                    [borderColor]="progress.borderColor" [icon]="progress.icon" [label]="progress.label"
                    [textColor]="progress.textColor" (click)="onProgressFilterChange(progress, false)">
                  </app-status-tag>
                  }
                </div>
                }
                <button nz-button nzType="text" nz-dropdown
                  [nzDropdownMenu]="filter.name === 'requisitionPriority' ? priorityFilterMenu
                  : (filter.name === 'requisitionStatus' ? statusFilterMenu : progressFilterMenu)"
                  nzTrigger="click" nzOverlayClassName="columnsMenuDropdown">
                  <span nz-icon nzType="down" nzTheme="outline" style="color: #999999"></span>
                </button>
              </th>
              <nz-dropdown-menu #priorityFilterMenu="nzDropdownMenu">
                <ul nz-menu class="columns-menu-container">
                  @for (priority of priorityList; track priority.id) {
                    <li nz-menu-item (click)="onPriorityFilterChange(priority)">
                      <app-priority-tag [backgroundColor]="priority.backgroundColor" [borderColor]="priority.borderColor"
                        [label]="priority.label" [textColor]="priority.textColor"></app-priority-tag>
                    </li>
                  }
                </ul>
              </nz-dropdown-menu>
              <nz-dropdown-menu #statusFilterMenu="nzDropdownMenu">
                <ul nz-menu class="columns-menu-container">
                  @for (state of statusList; track state.id) {
                  <li nz-menu-item nzType="text" (click)="onStatusFilterChange(state)">
                    <app-status-tag [backgroundColor]="state.backgroundColor" [borderColor]="state.borderColor"
                      [icon]="state.icon" [label]="state.label" [textColor]="state.textColor"></app-status-tag>
                  </li>
                  }
                </ul>
              </nz-dropdown-menu>
              <nz-dropdown-menu #progressFilterMenu="nzDropdownMenu">
                <ul nz-menu class="columns-menu-container">
                  @for (progress of progressList; track progress.id) {
                  <li nz-menu-item nzType="text" (click)="onProgressFilterChange(progress)">
                    <app-status-tag [backgroundColor]="progress.backgroundColor" [borderColor]="progress.borderColor"
                      [icon]="progress.icon" [label]="progress.label" [textColor]="progress.textColor"></app-status-tag>
                  </li>
                  }
                </ul>
              </nz-dropdown-menu>
              }
              @else if (filter.hasDateFilter && filter.isVisible) {
                @if (filter.name === 'requisitionApplicationDate' && selectedApplicationDates) {
                <th>
                  <nz-range-picker [nzAllowClear]="true" [nzShowTime]="false" [nzFormat]="'dd-MM-yy'" [nzRanges]="ranges"
                    [(ngModel)]="selectedApplicationDates.dates" (ngModelChange)="onDateFilterChange($event, filter.name)"
                    [nzPlaceHolder]="['Inicio','Fin']"></nz-range-picker>
                </th>
                }
                @else if (filter.name === 'requisitionExpectedDeliveryDate' && selectedExpectedDeliveryDates) {
                <th>
                  <nz-range-picker [nzAllowClear]="true" [nzShowTime]="false" [nzFormat]="'dd-MM-yy'" [nzRanges]="ranges"
                    [(ngModel)]="selectedExpectedDeliveryDates.dates"
                    (ngModelChange)="onDateFilterChange($event, filter.name)"
                    [nzPlaceHolder]="['Inicio','Fin']"></nz-range-picker>
                </th>
                }
              }
              @else if (filter.isVisible) {
              <th></th>
              }
            }
            <ng-template #suffixIconSearch>
              <span nz-icon nzType="search" class="filter-icon"></span>
            </ng-template>
          </tr>
        </thead>
        <tbody>
          @for (data of sortTable.data; track data.requisitionId; let i = $index) {
            <tr class="selectable-row" (click)="onGoToRequisitionDetails(data, $event)">
              <td nzAlign="center">
                <label nz-checkbox (nzCheckedChange)="onSelectRequisition(i, $event)"
                  [(ngModel)]="currentPageRequisitions[i]!.isSelected"></label>
              </td>
              @if (requisitionColumnsList[requisitionColumnsEnum.UserWhoRequests].isVisible) {
              <td>
                <div class="requester-container">
                  <div class="profile-image">
                    <img
                      src="{{(data.userWhoRequests && data.userWhoRequests.img !== '')
                        ? data.userWhoRequests.img
                        : '../../../../assets/UserOutlined.svg'}}">
                  </div>
                  <div class="requester-info">
                    <span class="requester-name">{{ (data.userWhoRequests && data.userWhoRequests.name) || 'No disponible'}}</span>
                    <span>{{ (data.userWhoRequests && data.userWhoRequests.role) || 'No disponible'}}</span>
                  </div>
                </div>
              </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionKey].isVisible && currentTab === tabIndex) {
                <td class="id-column">
                  {{ data.requisitionKey || 'No disponible' }}
                  @if (!currentPageRequisitions[i]!.isIdTooltipVisible) {
                    <span nz-icon nzType="link" nzTheme="outline" class="copy-icon"
                      nz-tooltip nzTooltipTitle="Copiar al portapapeles" 
                      (click)="onCopyToClipboard(data.requisitionKey, i, $event, true)"></span>
                  }
                  @if (currentPageRequisitions[i]!.isIdTooltipVisible) {
                    <span nz-icon nzType="check-circle" nzTheme="outline" class="copied-icon"
                      nz-tooltip nzTooltipTitle="Copiado" [nzTooltipTrigger]="null"
                      [nzTooltipVisible]="currentPageRequisitions[i]!.isIdTooltipVisible"></span>
                  }
                </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionFolio].isVisible && currentTab === tabIndex) {
                <td class="folio-column">
                  {{ data.requisitionFolio | number : '3.0-0': 'en-US'}}
                  @if (!currentPageRequisitions[i]!.isFolioTooltipVisible) {
                    <span nz-icon nzType="link" nzTheme="outline" class="copy-icon"
                      nz-tooltip nzTooltipTitle="Copiar al portapapeles" 
                      (click)="onCopyToClipboard(data.requisitionKey, i, $event)"></span>
                  }
                  @if (currentPageRequisitions[i]!.isFolioTooltipVisible) {
                    <span nz-icon nzType="check-circle" nzTheme="outline" class="copied-icon"
                      nz-tooltip nzTooltipTitle="Copiado" [nzTooltipTrigger]="null"
                      [nzTooltipVisible]="currentPageRequisitions[i]!.isFolioTooltipVisible"></span>
                  }
                </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionDescription].isVisible) {
                <td>
                  <div class="description-column">
                    <div class="info">
                      <span class="description">{{ data.requisitionDescription }}</span>
                    </div>
                    @if (data.requisitionIsHighlighted) {
                    <button class="action-icon-buttons" nz-button nzType="text"
                      (click)="onHighlightRequisition(data, false, i, $event)"
                      nz-tooltip nzTooltipTitle="Eliminar de favoritos">
                      <span nz-icon nzType="star" nzTheme="outline"></span>
                    </button>
                    }
                    @if (data.requisitionNotes && data.requisitionNotes !== '') {
                    <button class="action-icon-buttons"
                      nz-button nzShape="circle" nzType="dashed"
                      (click)="onSelectNote(data.requisitionId, $event)"
                      nz-tooltip nzTooltipTitle="Da clic a la celda para revisar las observaciones o notas de esta requisición.">
                      <img class="icon action-icon-buttons" src="assets/TwoTone.svg">
                    </button>
                    }
                  </div>
                </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionProject].isVisible) {
                <td>
                  <div class="description-column">
                    <div class="info">
                      <span class="key">{{data.project.projectName}}</span>
                    </div>
                  </div>
                </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionApplicationDate].isVisible) {
              <td nzAlign="center">
                {{ (data.requisitionApplicationDate | date: 'dd-MM-yyyy') || 'No disponible' }}
              </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionExpectedDeliveryDate].isVisible) {
              <td nzAlign="center">
                {{ (data.requisitionExpectedDeliveryDate| date: 'dd-MM-yyyy') || 'No disponible' }}
              </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.TotalCost].isVisible) {
                <td nzAlign="right">{{data.totalCost ? '$' : ''}}{{(data.totalCost | number : '1.2-2': 'en-US') ?? 'No disponible'}}</td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.UserWhoBuys].isVisible) {
              <td>
                <div class="requester-container">
                  <div class="profile-image">
                    <img
                      src="{{(data.userWhoBuys && data.userWhoBuys.img !== '')
                        ? data.userWhoBuys.img
                        : '../../../../assets/UserOutlined.svg'}}">
                  </div>
                  <div class="requester-info">
                    <span class="requester-name">{{ (data.userWhoBuys && data.userWhoBuys.name) || 'No disponible'}}</span>
                    <span>{{ (data.userWhoBuys && data.userWhoBuys.role) || 'No disponible'}}</span>
                  </div>
                </div>
              </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.UserWhoAuthorizes].isVisible) {
              <td>
                <div class="requester-container">
                  <div class="profile-image">
                    <img
                      src="{{(data.userWhoAuthorizes && data.userWhoAuthorizes.img !== '')
                        ? data.userWhoAuthorizes.img
                        : '../../../../assets/UserOutlined.svg'}}">
                  </div>
                  <div class="requester-info">
                    <span class="requester-name">{{ (data.userWhoAuthorizes && data.userWhoAuthorizes.name) || 'No disponible'}}</span>
                    <span>{{ (data.userWhoAuthorizes && data.userWhoAuthorizes.role) || 'No disponible'}}</span>
                  </div>
                </div>
              </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.UserWhoReviews].isVisible) {
              <td>
                <div class="requester-container">
                  <div class="profile-image">
                    <img
                      src="{{(data.userWhoReviews && data.userWhoReviews.img !== '')
                        ? data.userWhoReviews.img
                        : '../../../../assets/UserOutlined.svg'}}">
                  </div>
                  <div class="requester-info">
                    <span class="requester-name">{{ (data.userWhoReviews && data.userWhoReviews.name) || 'No disponible'}}</span>
                    <span>{{ (data.userWhoReviews && data.userWhoReviews.role) || 'No disponible'}}</span>
                  </div>
                </div>
              </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionPriority].isVisible) {
              <td nzAlign="center">
                <div class="priority-tag-container">
                  <app-priority-tag [backgroundColor]="data.requisitionPriority.backgroundColor"
                    [borderColor]="data.requisitionPriority.borderColor" [label]="data.requisitionPriority.label"
                    [textColor]="data.requisitionPriority.textColor"></app-priority-tag>
                </div>
              </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionStatus].isVisible) {
              <td nzAlign="center">
                <app-status-tag [backgroundColor]="data.requisitionStatus.backgroundColor"
                  [borderColor]="data.requisitionStatus.borderColor" [icon]="data.requisitionStatus.icon"
                  [label]="data.requisitionStatus.label" [textColor]="data.requisitionStatus.textColor"></app-status-tag>
              </td>
              }
              @if (requisitionColumnsList[requisitionColumnsEnum.RequisitionProgress].isVisible) {
              <td nzAlign="center">
                <app-status-tag [backgroundColor]="data.requisitionProgress!.backgroundColor"
                  [borderColor]="data.requisitionProgress!.borderColor" [icon]="data.requisitionProgress!.icon"
                  [label]="data.requisitionProgress!.label" [textColor]="data.requisitionProgress!.textColor"></app-status-tag>
              </td>
              }
              <td>
                <button nz-button class="action-icon-buttons" nzType="text"
                  nzShape="circle" nz-dropdown (click)="blockEvent($event)"
                  [nzDropdownMenu]="actionsMenu" [nzTrigger]="'click'"
                  nz-tooltip nzTooltipTitle="Ver más opciones">
                  <span nz-icon nzType="more"></span>
                </button>
                <nz-dropdown-menu #actionsMenu="nzDropdownMenu">
                  <ul nz-menu nzSelectable>
                    @if (data.requisitionIsHighlighted) {
                    <li nz-menu-item (click)="onHighlightRequisition(data, false, i, $event)">
                      <span nz-icon nzType="star" nzTheme="outline"></span>
                      Dejar de destacar
                    </li>
                    } @else {
                    <li nz-menu-item (click)="onHighlightRequisition(data, true, i, $event)">
                      <span nz-icon nzType="star" nzTheme="outline"></span>
                      Destacar
                    </li>
                    }
                    <li nz-menu-item (click)="onGoToRequisitionDetails(data, $event)">
                      <span nz-icon nzType="edit" nzTheme="outline"></span>
                      Ir a detalle
                    </li>
                    @if (data.requisitionNotes && data.requisitionNotes !== '') {
                      @if (openedNotes.has(data.requisitionId)) {
                        <li nz-menu-item (click)="onCloseNote(data.requisitionId)">
                          <span nz-icon nzType="contacts" nzTheme="outline"></span>
                          Cerrar nota
                        </li>
                      } @else {
                        <li nz-menu-item (click)="onSelectNote(data.requisitionId, $event)">
                          <span nz-icon nzType="contacts" nzTheme="outline"></span>
                          Ver nota
                        </li>
                      }
                    }
                    <li nz-menu-item (click)="onDeleteRequisition(data.requisitionId, $event)">
                      <span nz-icon nzType="delete" nzTheme="outline"></span>
                      Eliminar
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>
            @if (openedNotes.has(data.requisitionId)) {
              <tr class="note-row">
                <td class="note-info">
                  <span>{{data.requisitionNotes}}</span>
                  <button nz-button nzType="text" (click)="onCloseNote(data.requisitionId)">
                    <span nz-icon nzType="close" nzTheme="outline"></span>
                  </button>
                </td>
              </tr>
            }
          }
        </tbody>
      </nz-table>
      <div class="pagination-container">
        <div class="table-pagination" [ngStyle]="{'width': 'calc(' + paginatorItems.length + '* 110px)'}">  
          <span>Total {{totalRequisitions}}</span>
          @for (item of paginatorItems; track item; let j = $index) {
          <button nz-button nzType="default" (click)="onPageIndexChange(j + 1)"
            [ngClass]="(j + 1) === currentPage ? 'highlighted' : ''"
            [disabled]="(j + 1) === currentPage">{{j + 1}}</button>
          }
          <button nz-button nzType="default" nz-dropdown nzTrigger="click" [nzDropdownMenu]="paginatorMenu">
            {{pageSize}} / página
          </button>
          <nz-dropdown-menu #paginatorMenu="nzDropdownMenu">
            <ul nz-menu>
              @for (pages of itemsPerPage; track pages) {
              <li nz-menu-item (click)="onPageSizeChange(pages)">{{pages}}</li>
              }
            </ul>
          </nz-dropdown-menu>
        </div>
        <ng-template #totalTemplate let-total>Total {{ totalRequisitions }} items</ng-template>
      </div>
    </nz-tab>
    }
  </nz-tabset>
  </nz-spin>
  <ng-template #emptyRequisitions>
    <nz-empty [nzNotFoundContent]="null" [nzNotFoundImage]="'assets/Empty.svg'">
    </nz-empty>
    <span class="empty-requisitions">
      Aún no tienes requisiciones
    </span>
  </ng-template>
  <ng-template #emptyFilteredRequisitions>
    <nz-empty [nzNotFoundContent]="null" [nzNotFoundImage]="'assets/NoResultsOutlined.svg'">
    </nz-empty>
    <span class="empty-requisitions">
      No se encontraron coincidencias con los criterios seleccionados.
    </span>
  </ng-template>
  <ng-template #clearAllFilters>
    <button nz-button nzType="link" (click)="onClearAllFilters()"
      [disabled]="project === undefined || appliedFilters === undefined">
      <span nz-icon nzType="clear" nzTheme="outline"></span>
      Limpiar filtros</button>
  </ng-template>
</div>
